// angular imports
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

// cc-commin imports
import { IconConstants, Utils } from 'cc-common';

// component imports
import { DxPopupComponent } from 'devextreme-angular';

// constant imports
import { WorkflowEditorActionConstants } from '../../../../shared-workflow-module/_constants/workflow-editor-action-constants';

@Component({
    selector: 'app-workflow-acct-step-deny',
    templateUrl: './workflow-acct-step-deny.component.html',
    styleUrls: ['./workflow-acct-step-deny.component.scss']
})
export class WorkflowAcctStepDenyComponent implements OnInit {
    @ViewChild('denyFromWorkflowEditorPopup', { static: false }) denyFromWorkflowEditorPopup: DxPopupComponent;

    @Output() onClose = new EventEmitter<void>();
    @Output() onDenyToCAM = new EventEmitter<string>();
    @Output() onDenyToAAP = new EventEmitter<string>();

    visible = false;

    reasonToDeny: string;
    denyWorkflowReasonMaxLength = 500;
    denyActions: Array<any> = [];
    selectedDenyAction: string;

    iconCancel = IconConstants.CANCEL;
    iconCheck = IconConstants.CHECK;

    ngOnInit() {
        this.denyActions = [
            {
                action: WorkflowEditorActionConstants.DENIED_RETURN_TO_CAM,
                text: 'Denied - Return To CAM'
            },
            {
                action: WorkflowEditorActionConstants.DENIED_SEND_TO_AAP,
                text: 'Denied - Send To AAP'
            }
        ];
        this.selectedDenyAction = WorkflowEditorActionConstants.DENIED_RETURN_TO_CAM;

        this.show();
    }

    show(): void {
        this.visible = true;
    }

    onPopupShown(): void {
        this.denyFromWorkflowEditorPopup.instance.repaint();
    }

    onPopupClose(): void {
        this.closeDenyFromWorkflowEditor();
    }

    onCancelClick(): void {
        this.closeDenyFromWorkflowEditor();
    }

    onReasonValueChanged(e: any): void {
        this.reasonToDeny = e.event.target.value;
    }

    getCharacterCount(): number {
        return Utils.notNullOrEmpty(this.reasonToDeny) ? this.reasonToDeny.length : 0;
    }

    onOkClick(): void {
        if (this.selectedDenyAction === WorkflowEditorActionConstants.DENIED_RETURN_TO_CAM) {
            this.onDenyToCAM.emit(this.reasonToDeny);
        } else if (this.selectedDenyAction === WorkflowEditorActionConstants.DENIED_SEND_TO_AAP) {
            this.onDenyToAAP.emit(this.reasonToDeny);
        }

        this.closeDenyFromWorkflowEditor();
    }

    private closeDenyFromWorkflowEditor(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
